import styled from "styled-components";

export const Container = styled.div`
  box-sizing: border-box;
  padding: 1.5rem;
  width: 100%;
`;

export const Row = styled.div`
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background-size: 1400px 104px;
  background: #ffffff;
  background: linear-gradient(to right, #ffffff 8%, #f6f6f6 18%, #ffffff 33%);
  border-radius: 1rem;
  height: 6.3rem;
  margin: 1rem 0;
  position: relative;

  @keyframes placeHolderShimmer {
    0% {
      background-position: -668px 0;
    }
    100% {
      background-position: 668px 0;
    }
  }
`;

interface ITableHeader {
  hasCheckbox?: any;
}
export const TableHeader = styled.div<ITableHeader>`
  ${({ theme, hasCheckbox }) => `
    color: ${theme.colors.gray};
    font-family: ${theme.fontFamilies.primaryFont};
    grid-template-columns: ${
      hasCheckbox
        ? "4rem repeat(4, 1fr) 40rem 15rem"
        : "repeat(4, 1fr) 40rem 15rem"
    };
`}
  display: grid;
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 1rem;
  padding: 0 1.5rem;

  div {
    align-items: center;
    display: flex;
    flex-direction: column;
  }

  .left-align {
    align-items: flex-start;
  }
`;
